// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2S74-","assignButton":"CreateEditEquipmentSchedule_assignButton__1yNIh"};